/**
 * Competitive Dimensions Appendix Slide
 * Moved from Market slide — details on competitive dimensions for market share
 */

import React from 'react';
import styled from 'styled-components';
import { colors } from '@config/colors';
import { spacing, borderRadius } from '@config/spacing';
import {
  SlideBase,
  SlideContent,
  SlideHeader,
  SlideAccentGlow,
  SlideAccentGlowBottom,
  SlideSectionTitle,
  DarkInsightEmphasis,
} from '@components/press/pitch-deck/slide-primitives';
import { SlideAlertPanel, SlideAlertBox } from '@components/press/pitch-deck/slide-primitives';

const AlertBackdrop = styled.div`
  width: 100%;
  max-width: 960px;
  background: linear-gradient(135deg, ${colors.highlight.dark} 0%, ${colors.highlight.light} 100%);
  border-radius: ${borderRadius.xl};
  padding: ${spacing['2xl']} ${spacing.xl};
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};

  & > * > div {
    border: none;
    &::after {
      border-color: ${colors.accent.coral.light}40;
      display: block;
    }
  }

  ${DarkInsightEmphasis} {
    color: rgba(255, 255, 255, 0.95);
  }
`;

const WhiteSectionTitle = styled(SlideSectionTitle)`
  color: #fff;
  padding-bottom: ${spacing.md};
`;

export const CompetitiveDimensionsSlide: React.FC = () => (
  <SlideBase>
    <SlideAccentGlow />
    <SlideAccentGlowBottom />
    <SlideContent>
      <SlideHeader
        title="Competitive Dimensions"
        subtitle="Key dimensions that drive market share in household AI"
      />

      <AlertBackdrop>
        <WhiteSectionTitle>Competitive Dimensions for Market Share</WhiteSectionTitle>
        <SlideAlertPanel columns={2}>
          <SlideAlertBox headline="Trust">
            Families share sensitive data (finances, health, schedules, goals); trust is required to open <DarkInsightEmphasis>relationships with moms</DarkInsightEmphasis>
          </SlideAlertBox>

          <SlideAlertBox headline="Coverage">
            Moms handle it all, an AI that supports Moms <DarkInsightEmphasis>has to as well</DarkInsightEmphasis>
          </SlideAlertBox>

          <SlideAlertBox headline="Community Reputation">
            Moms have tight knit in real life social networks. Distribution will require <DarkInsightEmphasis>partnerships to extend reach</DarkInsightEmphasis> beyond the online.
          </SlideAlertBox>

          <SlideAlertBox headline="Household Memory">
            The more context an AI has about a specific household, the better its recommendations. This <DarkInsightEmphasis>compounds into an unassailable relationship moat</DarkInsightEmphasis> over time.
          </SlideAlertBox>
        </SlideAlertPanel>
      </AlertBackdrop>
    </SlideContent>
  </SlideBase>
);
